import React from 'react';
import PropTypes from 'prop-types';

function LayersForward({ size, stroke = 'currentColor', ...otherProps }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke={stroke}
      {...otherProps}
    >
      <path
        id="Stroke"
        d="M17.9 18.5V20.3C17.9 20.9627 17.3627 21.5 16.7 21.5H4.7C4.03726 21.5 3.5 20.9627 3.5 20.3V8.3C3.5 7.63726 4.03726 7.1 4.7 7.1H6.5M7.7 17.3L20.9 4.1M11.9 17.9L21.5 8.9M16.1 17.9L21.5 12.5M16.7 3.5L7.1 13.1M11.9 3.5L7.1 8.3M8.3 17.9H20.3C20.9627 17.9 21.5 17.3627 21.5 16.7V4.7C21.5 4.03726 20.9627 3.5 20.3 3.5H8.3C7.63726 3.5 7.1 4.03726 7.1 4.7V16.7C7.1 17.3627 7.63726 17.9 8.3 17.9Z"
      />
    </svg>
  );
}

LayersForward.propTypes = {
  stroke: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  strokeWidth: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
};

export default LayersForward;
